import styled from 'styled-components'

const Status = styled('h2')`
  color: ${props => props.theme.colors.text.one};
  font-family: 'Roboto', sans-serif;
  text-align: center;
  font-size: 40px;
  margin-bottom: 0;
`

export default Status
